export default {"src":"/_next/static/media/CRWD.f63d836b.svg","height":18,"width":18};